export enum VehicleType {
	CAR = "car",
	SUV = "suv",
	VAN = "van",
}